import { IsiPageRequestManagerRequest, IIsiPageRequestManagerRequestCallback, IIsiPageRequestManagerRequestArgs, IIsiPageRequestManagerRequestCallbackArgs } from "./IsiPageRequestManagerRequest";
import { doPostBackAsync } from "../../../core.ts";
import { IsiDtoHttpHandlerRequestV3, IsiDtoHttpHandlerRequestV4 } from "../../../../Dtos/Isilog.IsiFramework.IsiDataTransferObject";

// Register the namespace for the control.
//Type.registerNamespace('IsiFW');
//
// Define the control properties.
//
export class IsiPageRequestManager {

    static _instance: IsiPageRequestManager;

    requests: IsiPageRequestManagerRequest[];
    currentRequests: {};
    //this.requestsCallbackObjects = new Array();
    requestsQueue: IsiPageRequestManagerRequest[];
    currentQueuedRequest: IsiPageRequestManagerRequest = null;

    unload: boolean;
    _postbackTransaction: any;
    needStopAjax: boolean;
    _beforeAsyncPostBackdlg: () => void;
    _onAllRequestEndedHandler: any;
    _currentRequest: IsiPageRequestManagerRequest;

    constructor() {
        this.requests = new Array();
        this._currentRequest = null;
        this.currentRequests = {};
        //this.requestsCallbackObjects = new Array();
        this.requestsQueue = new Array();
        this.currentQueuedRequest = null;
        this.initialize();
        this.unload = false;

        IsiPageRequestManager._instance = this;
    }

    static getInstance() {
        return IsiPageRequestManager._instance;
    }

    initialize() {
        window.Sys.WebForms.PageRequestManager.getInstance().add_endRequest(function (me) {
            return function (sender, args) {
                me.onEndRequest(sender, args);
            }
        }(this));


    }
    dispose() {
        //this.requestsCallbackObjects = null;
        this.requestsQueue = null;

    }
    getMicrosoftPageRequestManager() {
        return window.Sys.WebForms.PageRequestManager.getInstance();
    }
    hasRequestInQueue() {
        return this.requestsQueue.length;
    }
    getRequest(id) {
        return this.requests[id];
    }
    stopAjax() {
        this.needStopAjax = true;
    }
    /**
     * Permet de setter un délégué appelé avant un postBack Asynchrone.
     * */
    setBeforeAsyncPostBackDlg(dlg: () => void) {
        this._beforeAsyncPostBackdlg = dlg;
    }
    canProcessRequest(request: IsiPageRequestManagerRequest) {
        if (this.needStopAjax) {
            return false;
        } else {
            if (request.IsiQueued) {
                return !this.getMicrosoftPageRequestManager().get_isInAsyncPostBack();
            } else {
                return true;
            }
        }
    }
    createRequestCallbackObject(sender, args: IIsiPageRequestManagerRequestCallbackArgs): IIsiPageRequestManagerRequestCallback {
        return {
            sender: sender,
            callback: args.callback,
            callbackParams: args.callbackParams,
            componentId: sender?.getId ? sender?.getId() : "",
            eventArgs: null
        };
    }
    createRequestErrorCallbackObject(sender, args: IIsiPageRequestManagerRequestCallbackArgs) {
        return {
            sender: sender,
            callback: args.errorCallback,
            callbackParams: args.errorCallbackParams,
            componentId: sender?.getId ? sender?.getId() : "",
            eventArgs: null
        };
    }
    IsiCreatePostBackRequest(sender, args, requestArgs, isBlocking) {
        var request =
            new IsiPageRequestManagerRequest("POSTBACK",
                requestArgs,
                this.generateRequestGuid(),
                isBlocking); //jQuery.toJSON(requestArgs)
        //LRAT

        request.IsiCallback = this.createRequestCallbackObject(sender, args);
        request.IsiCallback.eventArgs = requestArgs;
        request.IsiSender = sender;
        request.IsiQueued = true;
        return request;
    }
    IsiCreateAjaxRequest(sender, args: IIsiPageRequestManagerRequestCallbackArgs, requestArgs: IIsiPageRequestManagerRequestArgs, httpMethod: "GET" | "POST", url: string, queued: boolean, isBlocking: boolean) {
        var request = new IsiPageRequestManagerRequest("AJAX", requestArgs, this.generateRequestGuid(), isBlocking);
        request.IsiCallback = this.createRequestCallbackObject(sender, args);
        request.IsiErrorCallback = this.createRequestErrorCallbackObject(sender, args);
        request.IsiSender = sender;
        request.IsiHttpMethod = httpMethod;
        request.IsiUrl = url;
        request.IsiQueued = queued;
        return request;
    }
    IsiCreateComponentEventRequest(sender, args, requestArgs, isBlocking) {
        var request =
            new IsiPageRequestManagerRequest("COMPONENTEVENT",
                requestArgs,
                this.generateRequestGuid(),
                isBlocking); //jQuery.toJSON(requestArgs)
        //LRAT

        request.IsiCallback = this.createRequestCallbackObject(sender, args);
        request.IsiCallback.eventArgs = requestArgs;
        request.IsiSender = sender;
        request.IsiQueued = true;
        return request;
    }
    addRequestToQueue(request) {
        this.requestsQueue[this.requestsQueue.length] = request;
    }
    doRequest(request: IsiPageRequestManagerRequest) {
        var result;
        this._currentRequest = request;
        this.requests[request.IsiId] = request;

        request.IsiArgs.IsiRequestId = request.IsiId;
        switch (request.IsiType) {
            case "AJAX":
                result = this.doAjaxRequest(request);
                break;

            case "POSTBACK":
                result = this.doPostBackAsync(request);
                break;
            case "COMPONENTEVENT":
                result = this.doComponentRequest(request);
                break;
        }

        return result;
    }
    doPostBackAsync(request: IsiPageRequestManagerRequest) {

        // eventArgs.IsiAsyncCallId = this.createRequestCallbackObject(sender, args);

        if (this._postbackTransaction) {
            //GBAU - 09/01/2013 - DYSF54087 : Lorsque qu'une transaction existe, on ne ait rien tout de suite
            // car tous doit être traité en même temps en un seul repostage
            this._postbackTransaction.addEvent(request.IsiArgs);
        } else {
            if (this.canProcessRequest(request)) {
                //console.log("Launch async 1");
                this.currentQueuedRequest = request;
                if (this._beforeAsyncPostBackdlg) {
                    this._beforeAsyncPostBackdlg();
                }
                doPostBackAsync("IsiController", jQuery.toJSON(request.IsiArgs), null); /* function (me) {
                    return function (sender, args) {
                        me.onEndRequest(sender, args);
                    }
                } (this)); */
                //{"sender": sender, "args": args } //function (sender1, args1) { me.asyncCallBack(sender1, args1, sender, eventArgs, args.callback, args.callbackParams); }
            } else {
                this.addRequestToQueue(request);
            }
        }
    }
    /**
     * prépare les datas de la request.
     * @param request
     */
    private preparAjaxRequestData(request: IsiPageRequestManagerRequest): any {
        var data = request.IsiArgs.IsiData;
        if (request.IsiHttpMethod == "POST") {
            if (data instanceof IsiDtoHttpHandlerRequestV4) {
                data = JSON.stringify(data);
            } else {
                data = {};
                data.data = request.IsiArgs.IsiData;

                if (request.IsiArgs.IsiData["$type"]) {
                    data["$type"] = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.HttpHandlers.IsiDtoHttpHandlerRequest, Isilog.IsiFramework.IsiDataTransferObject";
                    data = JSON.stringify(data);
                } else {
                    data.__type = "IsiDtoHttpHandlerRequest:#Isilog.IsiFramework.IsiDataTransferObject.WebGUI.HttpHandlers";
                    data = window.Sys.Serialization.JavaScriptSerializer.serialize(data);
                }
            }
        }
        return data;
    }
    doAjaxRequest(request: IsiPageRequestManagerRequest) {

        //GBAU - 13/03/2015
        const data = this.preparAjaxRequestData(request);

        request.JAjaxRequest = jQuery.ajax({
            type: request.IsiHttpMethod,
            url: request.IsiUrl,
            beforeSend: function (xhr) {
                xhr.setRequestHeader("Content-Type", "application/json"); // type de contenu envoye
                xhr.setRequestHeader("Accept", "application/json"); // type de contenu accepte en retour
            },
            data: data,
            success: (responseData, status, xhr) => {

                responseData.get_error = function () { return null; };

                // GBAU - Modification pour le traitement des réponses avec les handler
                request.IsiResponse.IsiData = responseData;

                if (request.IsiArgs.IsiData instanceof IsiDtoHttpHandlerRequestV4) {
                    (<IsiDtoHttpHandlerRequestV4>request.IsiArgs.IsiData).response.init(responseData);
                }

                this.onEndRequest(request.IsiSender, responseData, request);
            },
            error: (jqXHR, textStatus, errorThrown) => {
                var responseData;
                // LBRI : en cas d'erreur http (40*, etc..) le responseJSON n'existe pas
                if (jqXHR.responseJSON) {
                    responseData = jqXHR.responseJSON;
                    if (request.IsiArgs.IsiData instanceof IsiDtoHttpHandlerRequestV4) {
                        request.IsiArgs.IsiData.response.init(responseData);
                    }
                } else {
                    responseData = {};
                }
                responseData.get_error = function () {
                    return true;
                };

                // GBAU - Modification pour le traitement des réponses avec les handler
                request.IsiResponse.IsiData = responseData;
                this.onEndRequest(request.IsiSender, responseData, request);

            }
        });
    }
    doComponentRequest(request: IsiPageRequestManagerRequest) {
        //request.IsiResponse.IsiData
        request.IsiCallback.eventArgs.get_error = function () { return null; };
        this.onEndRequest(request.IsiSender, request.IsiCallback.eventArgs, request);
    }
    onEndRequest(sender, args, request?: IsiPageRequestManagerRequest) {
        //console.log("onEndRequest : currentrequestId = " + requestId + " unload = " + this.unload);

        if (!request) {
            request = this.currentQueuedRequest;
        }
        if (request) {
            //[LRAT
            //var requestId = request.IsiCallback;
            if (!this.unload) {
                var requestCallbackObject = request.IsiCallback;

                if (uiCore.isDebug()) {
                    if (typeof (args) == "string") {
                        uiCore.showErrorMessage(args, { iframe: true });
                        return;
                    }
                }

                var error = args.get_error();
                if (error != null) {
                    if (typeof (args.set_errorHandled) !== 'undefined') {
                        //29/06/2016 - DEV123704 : Fonctionnement avec MicrosoftAjax
                        args.set_errorHandled(true);
                        error = {};
                        error.timeout = args.get_response().get_timedOut();
                        if (error.timeout) {
                            error.message = "timeout !";
                        }

                        request.IsiCallback.error = error;
                    } else {
                        //29/06/2016 - DEV123704 : Nouveau fonctionnement, on peut passer un callback a appeler en cas d'erreur
                        requestCallbackObject = request.IsiErrorCallback;
                    }
                }

                if (requestCallbackObject) {
                    var callback = requestCallbackObject.callback;
                    var callbackParams = requestCallbackObject.callbackParams;

                    callback(callbackParams);
                }

                if (this.hasRequestInQueue()) {
                    var request = this.requestsQueue[0];
                    if (!this.unload && this.canProcessRequest(request)) {
                        ////console.log("Launch async 2");             
                        this.requestsQueue.shift();
                        this.doRequest(request);
                    }
                } else {
                    this._currentRequest = null;
                    //Si on a plus de requête alors on lance un event indiquant qu'on a terminé de traiter toutes les requêtes
                    //this.stopAjax();
                    this._onAllRequestEnded(this, {});
                }
            }
        }

    }
    /**
     * Indique si la requête encours est blocante
     * */
    hasBlockingRequest() {
        return this._currentRequest !== null && this._currentRequest.IsiIsBlocking
    }
    /**
     * Ajoute le handler sur la fin  de toutes les requêtes en queue
     * @param {any} handler la fonction à appeler
     */
    add_OnAllRequestEnded(handler) {
        this._onAllRequestEndedHandler = handler;
    }
    /**
    * retire le handler sur la fin  de toutes les requêtes en queue
    */
    remove_OnAllRequestEnded() {
        this._onAllRequestEndedHandler = null;
    }
    /**
     * Evenement levé lorsque toutes les requêtes en queue sont finies
     * @param {any} sender le IsiPageRequestManager
     * @param {any} args vide
     */
    _onAllRequestEnded(sender, args) {
        if (this._onAllRequestEndedHandler) {
            this._onAllRequestEndedHandler("OnAllRequestEnded", args);
        }
    }
    generateRequestGuid() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }

        // then to call it, plus stitch in '4' in the third group
        return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4())
            .toLowerCase();
    }
    onApplicationUnload(sender, args) {
        //console.log("Controller : App Unload");
        var prm = window.Sys.WebForms.PageRequestManager.getInstance();
        this.unload = true;
        this.requests = new Array();
        this.requestsQueue = new Array();
        if (prm.get_isInAsyncPostBack()) {
            prm.abortPostBack();
        }
    }
    /**
     * Indique si le composant gère un état coté client (localStorage)
     * @returns boolean
     */
    useClientState() {
        return false;
    }
}

//IsiFW.IsiPageRequestManager.registerClass("IsiFW.IsiPageRequestManager", null);

//IsiFW.IsiPageRequestManagerRequest.registerClass("IsiFW.IsiPageRequestManagerRequest", null);

//IsiFW.IsiPageRequestManagerResponse.registerClass("IsiFW.IsiPageRequestManagerResponse", null);

//if (typeof (Sys) !== 'undefined') Sys.Application.notifyScriptLoaded();

//export = IsiPageRequestManager;
